import React, { Component } from 'react'
import Input from 'shared-web/src/components/Input'
import Select from 'components/shared/SelectWrapper'
import SimpleSelect from 'components/shared/SimpleSelect'
import _filter from 'lodash/filter'
import _map from 'lodash/map'

import withOrgTeams from 'app/modules/teams/hoc/withOrgTeams'

const OPTIONS = [
  { value: 'isAvailable', text: 'is online' },
  { value: 'isNotAvailable', text: 'is offline' },
]

class TeamSelectInputs extends Component {
  static defaultProps = {
    optionTypes: ['isAvailable', 'isNotAvailable'],
  }

  makeOnRemove(index) {
    return () => {
      const options = this.props.conditionValue.get('value')
      this.props.conditionUpdater('value', options.splice(index, 1))
    }
  }
  getTeamOptions() {
    return _map(this.props.teams, (team) => ({
      value: parseInt(team.id),
      label: team.name,
    }))
  }
  getAvailableOptions() {
    const options = this.props.conditionValue.get('value')
    return _filter(this.getTeamOptions(), ({ value }) => {
      const found = options.find((option) => {
        return option === value
      })
      return !found
    })
  }

  makeOnOptionSelect(index) {
    return (option) => {
      const options = this.props.conditionValue.get('value')
      this.props.conditionUpdater('value', options.set(index, option.value))
    }
  }

  renderStringInput(value, index, placeholder) {
    return (
      <Input
        valueLink={{
          requestChange: this.makeStringInputChange(index),
          value: value
        }}
        placeholder={placeholder}
        isValid={value}
      />
    )
  }

  onOperatorSelect(operator) {
    this.props.conditionUpdater('operator', operator)
  }

  getSelectedValue() {
    const { conditionValue } = this.props
    return _.keyBy(OPTIONS, 'value')[conditionValue.get('operator')].text
  }

  renderSelect() {
    const options = this.props.conditionValue.get('value')
    return options.map((option, index) => {
      return <Select
        className="team-select"
        value={option}
        options={this.getTeamOptions()}
        onChange={this.makeOnOptionSelect(index)}
        clearable={false}
      />
    })
  }

  render() {
    const { optionTypes } = this.props

    const options = _.filter(OPTIONS, ({ value }) => optionTypes.includes(value))

    return (
      <div className="flex-space-around flex-1 flex-wrap">
          {this.renderSelect()}
        <SimpleSelect
          onSelection={this.onOperatorSelect.bind(this)}
          options={options}
          selectedValue={this.getSelectedValue()}
        />
      </div>
    )
  }
}


export default withOrgTeams(TeamSelectInputs)



// WEBPACK FOOTER //
// ./src/scripts/components/CampaignWizards/TargetingInputArea/TargetConditionInput/TargetConditionEditModal/TeamSelectInputs.js